<template>
    <div v-if="month">
        <header class="calendar-header">
            <p class="calendar-month" v-text="this.month.format('MMMM YYYY')"></p>
            <p class="calendar-navigation">
                <span v-if="! previousIsPassed" @click.prevent="prevMonth" id="prev"><i class="fas fa-chevron-left"></i></span>
                <span v-else></span>
                <span @click.prevent="nextMonth" id="next"><i class="fas fa-chevron-right"></i></span>
            </p>
        </header>
        <div v-if="! loading && ! error" class="calendar-body">
            <div class="calendar-table-row calendar-table-top">
                <div><span>L</span></div>
                <div><span>M</span></div>
                <div><span>M</span></div>
                <div><span>G</span></div>
                <div><span>V</span></div>
                <div class="weekend"><span>S</span></div>
                <div class="weekend"><span>D</span></div>
           </div>
            <div class="calendar-table-row">
                <div v-for="day in startOfWeek" :key="'empty-'+day"></div>
                <div v-for="day in monthDays" :key="'day-'+day" :class="{'full': isNotAvailable( day ), 'weekend': isWeekend( day ), 'selected': isSelected( day ), 'passed': isPassed(day)}" @click="select( day )"><span v-text="day">1</span></div>
            </div>
        </div>
        <div v-if="loading" class="calendar-loader has-text-centered"><i class="fas fa-spin fa-circle-notch fa-3x"></i></div>
        <div v-if="error" class="has-text-centered has-text-danger">
            <strong class="has-text-danger" v-text="error.error">Error</strong> <span v-text="error.errorDetails.error.message">Error message</span>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    import axios from 'axios'

    export default {
        props: {
            value: null,
            employee: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                selected: false,
                today: false,
                month: false,
                loading: false,
                available: [],
                error: false
            }
        },
        mounted() {
            // todo check for locale
            moment.locale('IT_it');
            this.today = moment().startOf('day');
            if( moment.isMoment( this.value ) ) {
                this.selected = this.value
                this.month = moment( this.selected ).startOf('month');
            } else {
                this.month = moment().startOf('month');
            }
            this.fetchAvailableDays();
        },
        methods: {
            select( day ) {
                if( this.isWeekend( day ) || this.isPassed( day ) || this.isNotAvailable( day ) ) return;
                this.selected = moment( this.month ).date( day );
                this.$emit('input', this.selected);
            },
            prevMonth() {
                this.month = moment(this.month).subtract(1, 'month');
                this.fetchAvailableDays();
            },
            nextMonth() {
                this.month = moment(this.month).add(1, 'month');
                this.fetchAvailableDays();
            },
            isWeekend( day ) {
                let date = moment( this.month ).date( day );
                return ( date.day() === 0 || date.day() === 6 )
            },
            isSelected( day ) {
                if( ! this.selected ) return false
                let date = moment(this.month ).date( day )
                return this.selected.isSame( date )
            },
            isPassed( day ) {
                let date = moment(this.month ).date( day )
                return date.isBefore( this.today )
            },
            isNotAvailable( day ) {
                if( this.isPassed( day ) || this.isWeekend( day ) || this.isSelected( day ) ) return false;
                return ! this.available.includes( day )
            },
            fetchAvailableDays() {
                this.loading = true;
                axios.get('/calendar/api/'+this.employee.id+'/days/'+(this.month.month() + 1))
                    .then( response => {
                        this.available = response.data;
                        this.loading = false;
                    } )
                    .catch( error => {
                        this.error = error.response.data.response.original
                        this.loading = false
                    })
            }
        },
        computed: {
            startOfWeek() {
                let day = ( this.month.day() === 0 ) ? 6 : this.month.day() - 1;
                return day
            },
            monthDays() {
                return this.month.daysInMonth()
            },
            previousIsPassed() {
                let previous = moment(this.month).subtract(1, 'month')
                let month = moment( this.today ).startOf('month');
                return previous.isBefore( month )
            }
        },
        watch: {
            value( date ) {
                if( moment.isMoment( date ) ) {
                    this.selected = date;
                    this.month = moment( date ).startOf('month');
                }
            }
        }
    }
</script>